<template>
    <!-- https://headlessui.com/vue/radio-group -->
    <div class="bg-dark-light flex w-full items-center rounded-lg p-3">
        <div class="flex grow flex-col">
            <div class="text-xxs flex font-bold tracking-widest uppercase">
                <span>
                    <slot name="label">
                        {{ label }}
                        <BadgePremium v-if="premium" class="normal-case" />
                    </slot>
                </span>
                <!-- <span v-if="formatDisplayedValue.unit"> ({{ formatDisplayedValue.unit }})</span> -->
                <RequiredText v-if="required"> *</RequiredText>
                <div class="flex w-full justify-end" v-if="$slots.rightIcons"> <slot name="rightIcons" /> </div>
            </div>
            <Blur class="flex flex-col" :blurred="!$store.getters['auth/hasSubscriptionAccess'] && premium">
                <RadioGroup
                    :modelValue="modelValue"
                    @update:modelValue="(value) => emits('update:modelValue', value)"
                    class="mt-2"
                >
                    <RadioGroupLabel class="sr-only"> {{ label }} </RadioGroupLabel>
                    <div class="flex flex-nowrap space-x-3">
                        <RadioGroupOption
                            as="template"
                            v-for="option in options"
                            :key="option.id"
                            :value="option.id"
                            :disabled="option?.disabled"
                            v-slot="{ active, checked }"
                        >
                            <div
                                :class="[
                                    !option?.disabled
                                        ? 'cursor-pointer focus:outline-hidden'
                                        : 'cursor-not-allowed opacity-25',
                                    active ? 'ring-2 ring-indigo-500 ring-offset-2' : '',
                                    checked
                                        ? 'bg-brand-base border-transparent hover:bg-indigo-700'
                                        : 'bg-dark-lighter border-border hover:bg-dark-lightest',
                                    'flex w-fit items-center justify-center rounded-lg border px-3 py-1 text-sm font-medium whitespace-nowrap',
                                ]"
                            >
                                <RadioGroupLabel as="span">{{ option.value }}</RadioGroupLabel>
                            </div>
                        </RadioGroupOption>
                    </div>
                </RadioGroup>
            </Blur>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
// import { convertValueUnit, getUserUnit } from '@/lib/helpers/convert'
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import RequiredText from '@/components/form/RequiredText.vue'
import BadgePremium from '@/components/BadgePremium.vue'
import Blur from '@/components/Blur.vue'

const props = defineProps({
    modelValue: { type: [String, Number, Date, Boolean], default: '' },
    decimals: { type: Number, default: undefined },
    unit: { type: String, default: null },
    userUnit: { type: String, default: null },
    label: { type: String, default: '' },
    premium: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
})
const emits = defineEmits(['update:modelValue'])

// const userUnit = computed(() => (props.unit ? getUserUnit(props.unit, props.userUnit) : null))

// const formatDisplayedValue = computed(() =>
//     convertValueUnit(props.modelValue, props.unit, userUnit.value, props.decimals, true)
// )

// const formatRealValue = async (value) =>
//     emits('update:modelValue', convertValueUnit(value, userUnit.value, props.unit, props.decimals, true).value)
</script>
